import { Stack, Typography } from '@mui/material';
import { EnumProjectStatus, EnumTimedProjectPitchStatus } from 'tdc-web-backend/enums/enums';
import { ProjectStatsDto } from 'tdc-web-backend/projects/schemas';
import { PitchStatsDto } from 'tdc-web-backend/timed-project-pitches/schemas';
import { CaseStudyStatsDto } from 'tdc-web-backend/case-studies/schemas';
import { useTranslation } from 'react-i18next';
import useGetOne from '../../../../../../utils/hooks/crud-hooks/useGetOne';
import { primaryDark } from '../../../../../../utils/color';

const NumbersSupplier = () => {
  const { t } = useTranslation();

  const { data: projects, isLoading: isLoadingProjects } = useGetOne<ProjectStatsDto>({
    resource: `projects/stats?as=supplier`,
    refetchOnMount: true,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    retry: false,
    // onSuccess: (data) => {
    //   setIsTokenValid(true);
    // },
    // onError: () => {
    //   setIsTokenValid(false);
    // },
  });

  const { data: pitches, isLoading: isLoadingPitches } = useGetOne<PitchStatsDto>({
    resource: `timed-project-pitches/stats`,
    refetchOnMount: true,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    retry: false,
  });

  const { data: caseStudies, isLoading: isLoadingCaseStudies } = useGetOne<CaseStudyStatsDto>({
    resource: `case-studies/stats`,
    refetchOnMount: true,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    retry: false,
  });

  const activeProjects = projects?.data.filter(
    (status) => status.status === EnumProjectStatus.InProgress,
  )[0];
  const pendingProjects = projects?.data.filter(
    (status) => status.status === EnumProjectStatus.Pending,
  )[0];

  const activePitches = pitches?.data
    .filter(
      (status) =>
        status.status === EnumTimedProjectPitchStatus.FirstRound ||
        status.status === EnumTimedProjectPitchStatus.SecondRound,
    )
    .reduce((acc, curr) => acc + curr.count, 0);

  const noCaseStudies = caseStudies?.data.reduce((acc, curr) => acc + curr.count, 0);

  return (
    <Stack direction="row" spacing={8} sx={{ py: '50px' }}>
      <Stack direction="column" justifyContent="space-between" spacing={12}>
        <Stack spacing={2}>
          <Typography variant="heading4" sx={{ color: primaryDark[500] }}>
            {t('homescreen.activeProjects')}
          </Typography>
          <Typography variant="heading1" sx={{ color: primaryDark[600] }}>
            {activeProjects?.count || 0}{' '}
          </Typography>
        </Stack>
        <Stack spacing={2}>
          <Typography variant="heading4" sx={{ color: primaryDark[500] }}>
            {t('homescreen.activePitches')}
          </Typography>
          <Typography variant="heading1" sx={{ color: primaryDark[600] }}>
            {activePitches || 0}
          </Typography>
        </Stack>
      </Stack>
      <Stack direction="column" justifyContent="space-between" spacing={12}>
        <Stack spacing={2}>
          <Typography variant="heading4" sx={{ color: primaryDark[500] }}>
            {t('homescreen.pendingProjects')}
          </Typography>
          <Typography variant="heading1" sx={{ color: primaryDark[600] }}>
            {pendingProjects?.count || 0}
          </Typography>
        </Stack>
        <Stack spacing={2}>
          <Typography variant="heading4" sx={{ color: primaryDark[500] }}>
            {t('common.caseStudies')}
          </Typography>
          <Typography variant="heading1" sx={{ color: primaryDark[600] }}>
            {noCaseStudies || 0}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default NumbersSupplier;
